/* Version: 3.5.149 */
'use client';
var brandingColors = {
  // Primary Manulife Green
  light_4_green: '#CAEED9',
  light_3_green: '#ACE5C4',
  light_2_green: '#5CD790',
  light_1_green: '#00C46E',
  m_green: '#00A758',
  dark_1_green: '#06874E',
  dark_2_green: '#046138',
  dark_3_green: '#004427',
  // Primary Manulife Blue
  light_4_blue: '#C1D8F7',
  light_3_blue: '#76B0FF',
  light_2_blue: '#2D69FF',
  light_1_blue: '#1E1EE5',
  blue: '#0000C1',
  dark_1_blue: '#00009A',
  dark_2_blue: '#000082',
  dark_3_blue: '#000060',
  // Accent Coral
  light_4_coral: '#F6CCC7',
  light_3_coral: '#FCACA1',
  light_2_coral: '#F69082',
  light_1_coral: '#FF7769',
  coral: '#EC6453',
  dark_1_coral: '#D03A39',
  dark_2_coral: '#A00E18',
  dark_3_coral: '#830A10',
  // Neutral
  white: '#FFFFFF',
  light_2_grey: '#FAFAFA',
  light_1_grey: '#F5F5F5',
  // Not in Global CDS
  light_grey: '#EDEDED',
  dark_1_light_grey: '#E5E5E8',
  // Not in Global CDS
  dark_2_light_grey: '#DFE0E2',
  // Not in Global CDS
  dark_3_light_grey: '#C2C3C9',
  // Not in Global CDS
  // light_5_dark_navy: '#DDDEE4', // Not in CDN CDS
  light_4_dark_navy: '#8E90A2',
  light_3_dark_navy: '#5E6073',
  light_2_dark_navy: '#424559',
  light_1_dark_navy: '#34384B',
  dark_navy: '#282B3E',
  super_dark_navy: '#1E212F',
  // Not in Global CDS

  // Utility Colors
  red_error: '#DB1F00',
  link_green: '#046138',
  utility_success: '#06874E',
  utility_warning: '#F49600',
  utility_info: '#2D69FF',
  // Secondary Colors - Violet
  light_4_violet: '#D4D2E9',
  light_3_violet: '#9D8DBC',
  light_2_violet: '#836AA6',
  light_1_violet: '#533573',
  violet: '#604584',
  dark_1_violet: '#4C336B',
  dark_2_violet: '#331A53',
  dark_3_violet: '#261848',
  // Secondary Colors - Gold
  light_4_gold: '#FBE9C6',
  light_3_gold: '#F8D38A',
  light_2_gold: '#FCC457',
  light_1_gold: '#F9AB2E',
  gold: '#F49600',
  dark_1_gold: '#E38400',
  dark_2_gold: '#CE7612',
  dark_3_gold: '#A75900',
  // Secondary Colors - Turquoise
  light_4_turquoise: '#C5F4F1',
  light_3_turquoise: '#9DF3ED',
  light_2_turquoise: '#6AE7DF',
  light_1_turquoise: '#28D7CB',
  turquoise: '#06C7BA',
  dark_1_turquoise: '#05B2A7',
  dark_2_turquoise: '#08A298',
  dark_3_turquoise: '#0B9189'
};

export { brandingColors as default };
